module.exports = __webpack_public_path__ + "img/Vivi.7402ef2a.jpg";